export default __webpack_public_path__ + "static/media/vscode.5307fba4.svg";